import getStore from '../data/store/store';

/**
 * Util to get published status of the booking page from store.
 */
export default function getPublishedStatus(): boolean {
    let settings = getStore().publishingSettings;
    return (settings && settings.IsPublished) || false;
}
